import api from '@/services/api'
import version from '@/services/version'
import Vue from 'vue';

const SYNC_RUNNING = 2;
const SYNC_FINISH = 1;
const SYNC_WAITING = 0;

let defaultInter = {
	responses: {}, // => {form_id, action: {status, name}, reponse1, reponse2....}
	uid: null,
	sync: null,
	syncfinished: false,
	started_at: '',
	ended_at: '',
	geoloc: {latitude: null, longitude: null, accuracy: null},
}

const store = {
	namespaced: true,
	state: {
		interventions: {},
		// nombre de photos declarees et non confirmees, par mission : une mission
		// dont le formulaire est parti n'est pas pour autant entierement
		// synchronisee tant qu'il reste des photos a envoyer
		picturespending: {},
		// ids des photos confirmees par eKo (HTTP 201), par mission. Persiste en
		// localStorage avec les interventions, alors que les photos vivent en
		// IndexedDB : c'est la seule trace qui survit a la purge locale d'une
		// photo pourtant bien envoyee.
		picturessent: {},
		// ids declares dans un formulaire, absents de la base locale et jamais
		// confirmes : la photo est perdue, on ne peut plus rien en faire. Memorise
		// pour ne pas rejouer l'alerte a chaque synchronisation.
		pictureslost: {}
	},
	mutations: {
		setintervention(state, {uid, data}) {
			console.log('setintervention', uid, data);
			if (!state.interventions[uid]) {
				Vue.set(state.interventions, uid, JSON.parse(JSON.stringify({...defaultInter, ...{'uid':uid}, ...data})));
			} else {
				state.interventions[uid] = data
			}
		},
		setResponse(state, {uid, responseid, data}) {
			console.log('setResponse', uid, data);
			if (data.geoloc && data.geoloc.latitude) {
				state.interventions[uid].geoloc = data.geoloc;
			}
			state.interventions[uid].responses[responseid] = data;
			console.log('setResponse END', uid, data);
		},
		addResponse(state, {uid, responseid, action, prefilled}) {
			console.log('addResponse commit', uid, action);
			if (prefilled === undefined){
				prefilled = {};
			}
			if (!state.interventions[uid]) {
				Vue.set(state.interventions, uid, JSON.parse(JSON.stringify({...defaultInter, ...{'uid':uid}})));
			}
			state.interventions[uid].responses[responseid] = {
				action: action,
				finished: false,
				geoloc: {latitude: null, longitude: null, accuracy: null},
				...prefilled
			}
		},
		removeResponse(state, {uid, responseid}) {
			let responses = {...state.interventions[uid].responses};
			delete responses[responseid];
			state.interventions[uid].responses = responses;
		},
		reset(state) {
			state.interventions = {};
			state.picturespending = {};
			state.picturessent = {};
			state.pictureslost = {};
		},
		changesync(state, {uid, sync}) {
			if (state.interventions[uid]){
				state.interventions[uid].sync = sync;
			}
		},
		// une sync interrompue (page gelee, onglet ferme, timeout reseau) laisse
		// l'intervention en SYNC_RUNNING : le getter tosyncs ne la reprend jamais.
		// Au demarrage aucune sync ne peut etre reellement en cours.
		requeueRunning(state){
			Object.keys(state.interventions).forEach((uid) => {
				if (state.interventions[uid].sync === SYNC_RUNNING) {
					state.interventions[uid].sync = SYNC_WAITING;
				}
			})
		},
		remove(state, uid){
			let inter = {...state.interventions};
			delete inter[uid];
			state.interventions = inter;
			let pending = {...state.picturespending};
			delete pending[uid];
			state.picturespending = pending;
			let sent = {...state.picturessent};
			delete sent[uid];
			state.picturessent = sent;
			let lost = {...state.pictureslost};
			delete lost[uid];
			state.pictureslost = lost;
		},
		addsentpicture(state, {uid, id}){
			// l'etat persiste d'une version anterieure n'a pas la cle
			if (!state.picturessent) {
				Vue.set(state, 'picturessent', {});
			}
			let ids = state.picturessent[uid] || [];
			if (ids.indexOf(id) === -1) {
				Vue.set(state.picturessent, uid, [...ids, id]);
			}
		},
		addlostpictures(state, {uid, ids}){
			if (!state.pictureslost) {
				Vue.set(state, 'pictureslost', {});
			}
			let known = state.pictureslost[uid] || [];
			let add = ids.filter((id) => known.indexOf(id) === -1);
			if (add.length) {
				Vue.set(state.pictureslost, uid, [...known, ...add]);
			}
		},
		setpicturespending(state, {uid, pending}){
			// l'etat persiste d'une version anterieure n'a pas la cle
			if (!state.picturespending) {
				Vue.set(state, 'picturespending', {});
			}
			if (pending) {
				Vue.set(state.picturespending, uid, pending);
			} else {
				Vue.delete(state.picturespending, uid);
			}
		}
	},
	
	actions: {
		setIntervention: ({commit, state}, {uid, data}) => {
			commit('setintervention', {uid, data});
		},
		setResponse: ({commit, state}, {uid, responseid, data}) => {
			data.version = version.version;
			commit('setResponse', {uid, responseid, data});
		},
		addResponse: ({commit, state}, {uid, action, prefilled}) => {
			let responseid = Date.now();
			commit('addResponse', {uid,responseid, action, prefilled});
			return responseid;
		},
		removeResponse: ({commit, state}, {uid, responseid}) => {
			commit('removeResponse', {uid,responseid});
		},
		finishIntervention: async ({commit, state, dispatch}, {uid, etatid, start, end, finished}) => {
			console.log('actions finishIntervention', uid, etatid, start, end, finished)
			if (etatid !== undefined || start !== undefined || end !== undefined || finished !== undefined) {
				let data = state.interventions[uid];
				if (!data) {
					console.log('no data finishIntervention')
					data = JSON.parse(JSON.stringify({...defaultInter, ...{'uid':uid}}));
				}
				if (etatid) {
					data.toetatid = etatid;
				}
				if (finished) {
					data.syncfinished = finished;
				}
				if (start) {
					data.started_at = start;
				}
				if (end) {
					data.ended_at = end;
				}
				commit('setintervention', {uid, data});
			}
			try {
				commit('changesync', {uid:uid, sync: SYNC_RUNNING});
				let call = await api.post({
					url: 'intervention/v3/missions/' + uid + '/save',
					params: state.interventions[uid]
				})
				commit('changesync', {uid:uid, sync: SYNC_FINISH});
			} catch (err) {
				console.log('finishIntervention error', err);
				commit('changesync', {uid:uid, sync: SYNC_WAITING});
				return;
			}
			// hors du try : l'intervention est acceptee cote eKo, un echec d'envoi
			// de photo ne doit pas la remettre en attente et la faire reposter
			await dispatch('pictures/sync', {}, {root:true});
			await dispatch('checkPictures', uid);
		},
		// recalcule les photos declarees dans les formulaires de la mission qui
		// n'ont pas de confirmation d'envoi, et les remet en attente
		checkPictures: async ({getters, commit, dispatch}, uid) => {
			try {
				let ids = getters.declaredPictureIds(uid);
				let sent = getters.sentPictureIds(uid);
				let lost = getters.lostPictureIds(uid);
				let res = await dispatch('pictures/checkDeclared', {uid, ids, sent, lost}, {root: true});
				let pending = res ? res.pending : 0;
				commit('setpicturespending', {uid, pending});
				if (res && res.missing && res.missing.length) {
					commit('addlostpictures', {uid, ids: res.missing});
				}
				return pending;
			} catch (e) {
				// un inventaire local qui echoue ne doit pas interrompre la file
				// des missions a synchroniser
				console.log('checkPictures error', uid, e);
				return 0;
			}
		},
		// y compris les missions deja marquees synchronisees : c'est precisement
		// le cas ou une photo perdue ne repartait jamais
		checkAllPictures: async ({state, dispatch}) => {
			for (const uid of Object.keys(state.interventions)) {
				await dispatch('checkPictures', uid);
			}
		},
		requeueRunning: ({commit}) => {
			commit('requeueRunning');
		},
		// appelee par pictures/upload sur le seul 201 : la confirmation d'envoi
		// doit survivre a la disparition de la photo en base locale (purge des
		// photos synchronisees, eviction d'IndexedDB par le navigateur)
		markPictureSent: ({commit}, {uid, id}) => {
			if (!uid || id === undefined || id === null) {
				return;
			}
			commit('addsentpicture', {uid, id});
		},
		pushAll: ({commit, state, getters, dispatch}) => {
			// sequentiel et attendu : un forEach non attendu rendait tout await
			// sur pushAll illusoire et lancait toutes les interventions de front
			// fige la liste : tosyncs est reactif et finishIntervention modifie sync
			return [...getters.tosyncs].reduce((chain, item) => {
				return chain.then(() => dispatch('finishIntervention', {uid: item.uid}));
			}, Promise.resolve());
		},
		reset: ({commit, state}) => {
			commit('reset');
		},
		
		async delete(context, uid) {
			console.log('delete inter', uid);
			context.commit('remove', uid);
		},
		
		async removeSynced(context, evtids){
			console.log('removeSynced interventions');
			let inter = context.state.interventions;
			if (Object.keys(inter).length){
				Object.keys(inter).forEach((uid) => {
					// une mission dont des photos restent a envoyer n'est pas
					// entierement synchronisee : la purger perdrait la liste des
					// photos declarees, donc toute chance de les renvoyer
					if (context.getters.hasPendingPictures(uid)) {
						return;
					}
					if (inter[uid].sync == SYNC_FINISH && evtids.indexOf(uid) === -1) {
						context.commit('remove', uid);
					}
				})
			}
		},
	},
	getters: {
		getAll: (state) => {
			return state.interventions;
		},
		getIntervention: (state) => (uid) => {
			return state.interventions[uid] ? state.interventions[uid] : JSON.parse(JSON.stringify({...defaultInter, ...{'uid':uid}}));
		},
		getResponses: (state, getters) => ({uid, responseid}) => {
			let inter = getters.getIntervention(uid);
			return inter.responses[responseid] ? inter.responses[responseid] : {
				action: {status: '', name: ''}
			};
		},
		getSyncStatus: (state) => (uid) => {
			if (!state.interventions[uid]) {
				return null;
			}
			return state.interventions[uid].sync
		},
		getCountResponses: (state) => (uid) => {
			if (!state.interventions[uid]) {
				return 0;
			}
			return Object.keys(state.interventions[uid].responses).length;
		},
		hasRapportEnCours: (state) => (uid) => {
			if (!state.interventions[uid]) {
				return false;
			}
			
		},
		sentPictureIds: (state) => (uid) => {
			return (state.picturessent && state.picturessent[uid]) || [];
		},
		lostPictureIds: (state) => (uid) => {
			return (state.pictureslost && state.pictureslost[uid]) || [];
		},
		hasPendingPictures: (state) => (uid) => {
			return !!(state.picturespending && state.picturespending[uid]);
		},
		countPendingPictures: (state) => (uid) => {
			return (state.picturespending && state.picturespending[uid]) || 0;
		},
		// ids des photos citees par les formulaires de la mission, ex :
		// "myname-1786523051890":[1209,1210,...]. La definition du formulaire dit
		// quels champs sont des photos ; sans elle (formulaire non encore
		// rafraichi) on retient les valeurs numeriques des champs de type liste,
		// checkDeclared ne retenant de toute facon que les ids connus en base.
		declaredPictureIds: (state, getters, rootState, rootGetters) => (uid) => {
			let inter = state.interventions[uid];
			if (!inter || !inter.responses) {
				return [];
			}
			let ids = [];
			Object.values(inter.responses).forEach((response) => {
				let formid = response.action ? response.action.form_id : null;
				let form = formid ? rootGetters['forms/getform'](formid) : null;
				let names = form
					? form.filter((item) => item.Type == 'picture').map((item) => item.Name)
					: Object.keys(response);
				names.forEach((name) => {
					if (!Array.isArray(response[name])) {
						return;
					}
					response[name].forEach((value) => {
						if (typeof value === 'number') {
							ids.push(value);
						}
					});
				});
			});
			return [...new Set(ids)];
		},
		tosyncs: (state) => {
			return Object.values(state.interventions).filter((item) => {
				return item.sync == SYNC_WAITING;
			})
		}
		
	},
}

export default store